import fieldName, { COMBINED_REGEXP } from '../javascripts/name';
import filled from '../javascripts/filled';

export default function combiner(props, planter) {
  const {
    values,
    parents,
  } = planter;

  function combine(name) {
    if (!COMBINED_REGEXP.test(name)) {
      return;
    }

    const names = props.combine[parents.value[name]].parser(values.value[name]);

    Object
      .keys(names)
      .forEach((i) => { values.value[fieldName(parents.value[name], i)] = filled(names[i]) ? names[i] : ''; });
  }

  return {
    combine,
  };
}
